import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { ScrapRuleData, ScrapRuleResponse } from "../types/scrapRules.type";

const useScrapRule: (id: string) => UseQueryResult<ScrapRuleData, unknown> = (id) => {
    const privateAxios = usePrivateAxios();

  return useQuery<ScrapRuleResponse, unknown, ScrapRuleData>({
    queryKey: ['scrapRule', id],
    queryFn: () => privateAxios.get(`/maintenance/scrap_rules/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useScrapRule;
